export default {
  data () {
    return {
      dbObject: null,
      db: {
        config: {
          dbName: 'sheets',
          storeName: 'maps',
          version: 1
        }
      }
    }
  },
  methods: {

    // DBオープン
    openDb (callback) {
      // indexedDB の確認
      const indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB || window.oIndexedDB
      // const IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.mozIDBKeyRange || window.msIDBKeyRange || window.oIDBKeyRange
      if (window.indexedDB === undefined) {
        alert('Sorry, cannot use.')
        return false
      }

      const request = indexedDB.open(this.db.config.dbName, this.db.config.version)
      request.onsuccess = (e) => {
        this.dbObject = e.target.result
        // DBオープン成功時にコールバック
        if (callback !== undefined) {
          callback()
        }
      }
      request.onerror = (e) => {
        alert('[openDb Error] Sorry, application error.')
        return false
      }
      request.onupgradeneeded = (e) => {
        this.dbObject = e.target.result

        // DB初期化
        if (this.dbObject.objectStoreNames.contains(this.db.config.storeName)) {
          this.dbObject.deleteObjectStore(this.db.config.storeName)
        }
        const store = this.dbObject.createObjectStore(this.db.config.storeName, {
          keyPath: 'no', autoIncrement: true
        })

        // インデックス作成
        store.createIndex('time', 'time', { unique: false })
      }
    },

    // トランザクション開始
    startTransaction (type) {
      const tx = this.dbObject.transaction([this.db.config.storeName], type)
      return tx.objectStore(this.db.config.storeName)
    },

    // DB削除
    deleteDb () {
      indexedDB.deleteDatabase(this.db.config.dbName)
    }
  }
}
